import React from 'react'
export default () => <div>Alert dialog</div>
